import { Icon, ProgressBar, useErrorSentryLog } from "materia"
import { useTranslation } from "react-i18next"
import { Stars } from "../../../components/Stars"
import { useNavigateBack } from "../../../tools/useNavigateBack"
import s from "./BundleHeader.module.scss"

export const BundleHeaderError = ({ error }: { error: unknown }) => {
  // TODO [sentry-logging] https://jira.attensi.com/browse/WEB-18745
  // Find a better place to send Sentry logs from
  useErrorSentryLog(error)
  const navigateBack = useNavigateBack()
  const { t } = useTranslation()

  return (
    <div className={s.error}>
      <div className={s.header__centered}>
        <div className={s.header__widgetLayoutSize}>
          <button
            className={s.header__back}
            onClick={() => navigateBack()}
            aria-label="Go back"
          >
            <Icon icon="Chevron" size="large" className={s.header__chevron} />
          </button>
          <div className={s.header__title}>
            {t("error.BUNDLE_HEADER_FETCH_ERROR")}
          </div>
          <div className={s.header__progress}>
            <ProgressBar value={0} maxValue={1} />
          </div>
          <div className={s.header__stars}>
            <Stars count={1} max={1} size="extraSmall" />
            ?/?
          </div>
        </div>
      </div>
    </div>
  )
}
